'use strict';

var MarketProductGroupTDChartClassGroupsFilterFactory = function MarketProductGroupTDChartClassGroupsFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function TDChartClassGroupsFilter() {
    DemandFilter.call(this, 'market-product-group', 'thematic-demand-chart-market-class-groups');
    this.registerFilters(injectedFilters);
  }
  TDChartClassGroupsFilter.constructor = TDChartClassGroupsFilter;
  TDChartClassGroupsFilter.prototype = Object.create(DemandFilter.prototype);
  return TDChartClassGroupsFilter;
};
MarketProductGroupTDChartClassGroupsFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketProductGroupTDChartClassGroupsFilterFactory;